/**
 * Derive display initials from a user's name.
 *
 * Rules:
 * - "Rishikesh Pandey" → "RP" (first letter of each name)
 * - "rishikesh"        → "RI" (first two letters, uppercased)
 * - "A"                → "A"  (single character)
 * - ""                 → "?"  (fallback)
 */
export function getInitials(firstName?: string | null, lastName?: string | null): string {
  const first = (firstName || '').trim();
  const last = (lastName || '').trim();

  if (first && last) {
    return (first[0] + last[0]).toUpperCase();
  }
  if (first) {
    return first.substring(0, 2).toUpperCase();
  }
  return '?';
}
